import { ResType } from '../types'

class ApiResponse implements ResType {
	data: ResType['data']
	status: ResType['status']
	statusText: ResType['statusText']
	headers: ResType['headers']
	config: ResType['config']
	request: ResType['request']
	exception: ResType['exception']

	constructor({
		data = [],
		status = 200,
		statusText = '',
		headers = {},
		config = {},
		request = {},
		exception = {
			message: {
				errorMessage: '',
				timestamp: '',
				meta: {},
			},
		},
	} = {}) {
		this.data = data
		this.status = status
		this.statusText = statusText
		this.headers = headers
		this.config = config
		this.request = request
		this.exception = exception
	}
}

export { ApiResponse }
